import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function HowItWorks() {
  const {
    t
  } = useLanguage();
  const steps = [{
    number: '01',
    title: t('howItWorks.step1.title'),
    description: t('howItWorks.step1.description')
  }, {
    number: '02',
    title: t('howItWorks.step2.title'),
    description: t('howItWorks.step2.description')
  }, {
    number: '03',
    title: t('howItWorks.step3.title'),
    description: t('howItWorks.step3.description')
  }];
  return <section className="w-full py-32 px-6 bg-white" data-id="element-258">
      <div className="max-w-5xl mx-auto" data-id="element-259">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-260">
          <h2 className="text-6xl md:text-8xl font-black text-black mb-6 uppercase tracking-tighter leading-none" data-id="element-261">
            {t('howItWorks.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-262">
            {t('howItWorks.subtitle')}
          </p>
        </motion.div>
        <div className="space-y-16" data-id="element-263">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="flex flex-col md:flex-row gap-8 items-start" data-id="element-264">
              <div className="flex-shrink-0" data-id="element-265">
                <div className="w-20 h-20 border-4 border-black flex items-center justify-center" data-id="element-266">
                  <span className="text-3xl font-black font-mono" data-id="element-267">
                    {step.number}
                  </span>
                </div>
              </div>
              <div className="flex-1 pt-2" data-id="element-268">
                <h3 className="text-3xl font-black text-black mb-3 uppercase tracking-tight" data-id="element-269">
                  {step.title}
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-270">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="mt-20 border-t border-b border-black py-8" data-id="element-271">
          <p className="text-2xl font-black text-black text-center uppercase tracking-tight mb-2" data-id="element-272">
            {t('howItWorks.closing.title')}
          </p>
          <p className="text-gray-600 text-center" data-id="element-273">
            {t('howItWorks.closing.subtitle')}
          </p>
        </motion.div>
      </div>
    </section>;
}